import React from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import ConfirmedScreen from "./screens/ConfirmedScreen";
import CredencialScreen from "./screens/CredencialScreen";
import CredencialDepScreen from "./screens/CredencialDepScreen";
import AccompanyScreen from "./screens/AccompanyScreen";
import HomeScreen from "./screens/HomeScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import ChoiseScreen from "./screens/ChoiceScreen";
import FormTC from "./screens/FormTC";
import FormPG from "./screens/FormPG";

import AdminLogin from "./screens/admin/LoginAdminScreen";
import Dashboard from "./screens/admin/DashboardScreen";
import ForgetScreen from "./screens/ForgetScreen";
import ForgetResetScreen from "./screens/ForgetResetScreen";

import ForgetAdminScreen from "./screens/admin/ForgetScreen";
import ForgetAdminResetScreen from "./screens/admin/ForgetResetScreen";

import ChoisePassScreen from "./screens/ChoisePassScreen";
import ChoiseAdminPassScreen from "./screens/admin/ChoiseAdminPassScreen";

import PedidoDepAdminScreen from "./screens/admin/PedidoDepScreen";
import OperadorDepAdminScreen from "./screens/admin/OperadorDepScreen";

import GerUsersScreen from "./screens/admin/GerUsersScreen";
import OperadorTitAdminScreen from "./screens/admin/OperadorTitularScreen";
import PainelScreen from "./screens/admin/PainelScreen";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      localStorage.getItem("userInfo") ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{ pathname: "/login", state: { from: props.location } }}
        />
      )
    }
  />
);

const PrivateAdminRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(propsAdmin) =>
      localStorage.getItem("userInfoAdmin") ? (
        <Component {...propsAdmin} />
      ) : (
        <Redirect
          to={{ pathname: "/adminlogin", state: { from: propsAdmin.location } }}
        />
      )
    }
  />
);

const Routes = () => {
  return (
    <BrowserRouter>
      <Switch>
        <PrivateRoute path="/" component={HomeScreen} exact />
        <PrivateRoute path="/credencial" component={CredencialScreen} exact />
        <PrivateRoute
          path="/credencial-dependentes"
          component={CredencialDepScreen}
          exact
        />

        <PrivateRoute path="/accompany" component={AccompanyScreen} exact />
        <Route path="/login" component={LoginScreen} exact />
        <Route path="/register" component={RegisterScreen} exact />
        <Route path="/confirmed" component={ConfirmedScreen} exact />

        <Route path="/forgot-password" component={ForgetScreen} exact />
        <Route
          path="/forgot-password/:token"
          component={ForgetResetScreen}
          exact
        />

        <Route
          path="/forgot-admin-password"
          component={ForgetAdminScreen}
          exact
        />
        <Route
          path="/forgot-admin-password/:token"
          component={ForgetAdminResetScreen}
          exact
        />

        <Route path="/confirmed/:tokenx" component={ConfirmedScreen} exact />
        <PrivateRoute path="/choise" component={ChoiseScreen} exact />
        <PrivateRoute path="/formTC" component={FormTC} exact />
        <PrivateRoute path="/formPG" component={FormPG} exact />

        <PrivateRoute path="/choice-pass" component={ChoisePassScreen} exact />

        <Route path="/adminlogin" component={AdminLogin} exact />

        <PrivateAdminRoute
          path="/choice-adminpass"
          component={ChoiseAdminPassScreen}
          exact
        />
        <PrivateAdminRoute path="/dashboard" component={Dashboard} exact />
        <PrivateAdminRoute
          path="/pedidos-dep"
          component={PedidoDepAdminScreen}
          exact
        />

        <PrivateAdminRoute
          path="/operador-dep"
          component={OperadorDepAdminScreen}
          exact
        />
        <PrivateAdminRoute
          path="/operador-titular"
          component={OperadorTitAdminScreen}
          exact
        />

        <PrivateAdminRoute
          path="/gerencia-users"
          component={GerUsersScreen}
          exact
        />
        <PrivateAdminRoute path="/painel" component={PainelScreen} exact />
      </Switch>
    </BrowserRouter>
  );
};

export default Routes;
